import { Pill } from "PFComponents/pill";
import { useGetColor } from "PFCore/hooks/use_get_color";
import { Color } from "PFCore/types";

type ImportStatePillProps = {
  text: string;
  backgroundColor?: Color;
  textColor?: Color;
};

export const ImportStatePill = ({ text, backgroundColor, textColor }: ImportStatePillProps) => {
  const getColor = useGetColor();

  return (
    <Pill
      text={text}
      style={{
        ...(backgroundColor ? { backgroundColor: getColor(backgroundColor) } : {}),
        ...(textColor ? { color: getColor(textColor) } : {})
      }}
      small
    />
  );
};
